<ng-container *ngIf="show && vm$ | async; let vm">
  <ion-header
    class="ion-no-border"
    *ngIf="isPresentedInFilterModal"
    [ngClass]="
      vm.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : vm.platformType === PlatformEnum.mobile
          ? 'ion-header-modal-mobile'
          : 'ion-header-modal-desktop'
    "
  >
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          *ngIf="vm.platformType === platformService?.platformEnum?.desktop"
          data-cy="close-modal-button"
          (click)="close()"
        >
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-label
        class="account-balance-customer-selector"
        data-cy="select-customer-label"
      >
        {{ 'i18n.payments.accountBalance.selectCustomer' | translate }}
      </ion-label>
    </ion-toolbar>
  </ion-header>

  <ion-content
    class="customer-selection_content"
    [class.only-customer-list]="!isPresentedInFilterModal"
    [ngClass]="
      vm.platformType === PlatformEnum.tablet
        ? 'ion-content-modal-tablet'
        : vm.platformType === PlatformEnum.mobile
          ? 'ion-content-modal-mobile'
          : 'ion-content-modal-desktop'
    "
    scroll-y="false"
  >
    <div class="searchbar-section" slot="fixed">
      <h4
        *ngIf="
          vm.platformType !== platformService?.platformEnum?.mobile &&
          !isPresentedInFilterModal
        "
        class="customer-title"
        [ngClass]="
          vm.platformType === platformService?.platformEnum?.tablet
            ? 'customer-title-tablet'
            : ''
        "
      >
        {{ 'i18n.common.customer' | translate }}
      </h4>
      <ion-searchbar
        id="customer-selection-searchbar"
        data-cy="customer-selection-searchbar"
        class="search"
        mode="md"
        placeholder="{{
          'i18n.payments.accountBalance.searchCustomer' | translate
        }}"
        [(ngModel)]="searchText"
        (ionInput)="filterCustomers()"
      ></ion-searchbar>
    </div>
    <ng-container *ngIf="!allCustomers.length">
      <div class="no-customers-found" data-cy="no-customers-found-text">
        <p>
          {{ 'i18n.header.noCustomersFound' | translate }}
        </p>
      </div>
    </ng-container>

    <cdk-virtual-scroll-viewport
      class="customer-list"
      [ngClass]="{
        'touch': platformService.isTouchExperience$ | async,
        'only-list': isPresentedInFilterModal,
        'mobile': isMobile,
      }"
      [itemSize]="69"
      [minBufferPx]="800"
      [maxBufferPx]="1000"
    >
      <ion-list>
        <ion-item
          *ngIf="
            showAllCustomers && searchText === '' && allCustomers.length > 0
          "
          data-cy="select-all-customers"
          class="all-customers-item"
        >
          <ion-label id="all-selected">
            <h3>
              {{
                (allSelected
                  ? 'i18n.common.deselectAll'
                  : 'i18n.common.selectAll'
                ) | translate
              }}
            </h3>
          </ion-label>
          <ion-checkbox
            aria-labelledby="all-selected"
            slot="end"
            [checked]="allSelected"
            (ionChange)="selectAllCustomers()"
          ></ion-checkbox>
        </ion-item>

        <ng-container
          *cdkVirtualFor="
            let customerDepartmentInfo of allCustomers;
            let i = index
          "
        >
          <ion-item
            *ngIf="customerDepartmentInfo.customerNumber"
            data-cy="customer-list-item"
          >
            <ion-label
              id="customer-dept"
              data-cy="customer-title"
              class="customer-label"
            >
              <h3>
                <span class="label-customer-info-name">{{
                  customerDepartmentInfo?.customerName | titlecase
                }}</span>
                <span class="label-customer-info-number"
                  >&nbsp;( {{ customerDepartmentInfo?.customerNumber }} )</span
                >
              </h3>
            </ion-label>
            <ion-checkbox
              slot="end"
              aria-labelledby="customer-dept"
              [checked]="customerDepartmentInfo.isSelected"
              (ionChange)="selectCustomer(customerDepartmentInfo, i)"
            ></ion-checkbox>
          </ion-item>
        </ng-container>
      </ion-list>
    </cdk-virtual-scroll-viewport>
  </ion-content>

  <ion-footer
    class="customer-selection-footer"
    *ngIf="isPresentedInFilterModal"
    [ngClass]="
      platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-footer-modal-tablet'
        : vm.platformType === PlatformEnum.mobile
          ? 'ion-footer-modal-mobile'
          : 'ion-footer-modal-desktop'
    "
  >
    <div class="buttons-group">
      <ion-button
        class="usf-outline-green-button"
        (click)="close()"
        data-cy="cancel-button"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        class="usf-fill-green-button"
        (click)="multipleSwitch(selectedCustomers)"
        data-cy="save-button"
        [disabled]="selectedCustomers?.length <= 0"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </div>
  </ion-footer>
</ng-container>
